/**
 * @flow
 * @relayHash 5dd286c19ebf9d6132dfe595d40952a5
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateFormTemplateInput = {
  clientMutationId?: ?string,
  id: string,
  brand_id?: ?string,
  title?: ?string,
  description?: ?string,
  data?: ?string,
  schema?: ?string,
  ui_schema?: ?string,
};
export type Title_UpdateFormTemplateMutationVariables = {|
  input: UpdateFormTemplateInput
|};
export type Title_UpdateFormTemplateMutationResponse = {|
  +updateFormTemplate: ?{|
    +form_template: ?{|
      +id: string,
      +title: ?string,
    |}
  |}
|};
export type Title_UpdateFormTemplateMutation = {|
  variables: Title_UpdateFormTemplateMutationVariables,
  response: Title_UpdateFormTemplateMutationResponse,
|};
*/


/*
mutation Title_UpdateFormTemplateMutation(
  $input: UpdateFormTemplateInput!
) {
  updateFormTemplate(input: $input) {
    form_template {
      id
      title
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateFormTemplateInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "updateFormTemplate",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "UpdateFormTemplateInput!"
      }
    ],
    "concreteType": "UpdateFormTemplatePayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "form_template",
        "storageKey": null,
        "args": null,
        "concreteType": "FormTemplate",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "title",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "Title_UpdateFormTemplateMutation",
  "id": null,
  "text": "mutation Title_UpdateFormTemplateMutation(\n  $input: UpdateFormTemplateInput!\n) {\n  updateFormTemplate(input: $input) {\n    form_template {\n      id\n      title\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "Title_UpdateFormTemplateMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "Title_UpdateFormTemplateMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'dc42252328e95ba2e6cba488191f4127';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/Document/Template/Form/__generated__/Title_UpdateFormTemplateMutation.graphql.js